import Vue from 'vue';
import config from '../../config/index';

export default {
  // 获取访问日志列表
  getAccessLogList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysVisLog/page`, { params });
  },
  // 清空访问日志
  postDeleteAccessLog(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysVisLog/delete`, params);
  },
  // 导出访问日志
  getExportAccessLog(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysVisLog/export`, { params, responseType: "blob" });
  },
  // 获取操作日志列表
  getActionLogList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOpLog/page`, { params });
  },
  // 清空访问日志
  postDeleteActionLog(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysOpLog/delete`, params);
  },
  // 导出操作日志
  getExportActionLog(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOpLog/export`, { params, responseType: "blob" });
  }
};
